import mock from './mock';
import './navbar/navbarSearch';
import './auth/authentication';

mock.onAny().passThrough();
